import { Fragment, memo, PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes, { bool } from 'prop-types';
import classnames from 'classnames';
import { BookingContext, bookingView } from '~/components';
import { FittingDetails } from './fitting-details';
import { getSafety, reduxFormSelectors } from '~/utils';
import { MainDetails as DefaultMainDetails, MainDetailsManageAppointment } from './main-details';
import { QuestionsDetails } from './questions-details';
import style from './ReviewDetails.scss';
import { YourDetails as DefaultYourDetails } from './your-details';

export class ReviewDetails extends PureComponent {
  render() {
    const {
      history,
      questionsSectionsConfig,
      MainDetails,
      YourDetails,
      YourAddress,
      YourProducts,
      TreatmentListDetails,
      isRecommendedByAFriend,
    } = this.props;
    const appointmentView = this.context;

    return (
      <Fragment>
        <YourAddress />
        <YourProducts />
        {appointmentView === bookingView.appointment ? (
          <MainDetailsManageAppointment history={history} />
        ) : (
          <MainDetails history={history} />
        )}
        <YourDetails />
        <TreatmentListDetails />
        {questionsSectionsConfig[0] &&
        questionsSectionsConfig[0].displayQuestionsInYourDetails ? null : (
          <div
            className={classnames({ [style.QuestionDetailsContainer]: !!isRecommendedByAFriend })}
          >
            <FittingDetails />
            <QuestionsDetails />
          </div>
        )}
      </Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const {
    questions: { restoredAnswers: clientAnswers },
    client: { details: clientDetails },
    services: {
      config: { ReviewForm: ConfigsReviewForm },
    },
  } = state;

  // Access form values from restoredAnswers instead of redux-form
  return {
    clientAnswers: clientAnswers || {},
    clientDetails,
    MainDetails: getSafety(ConfigsReviewForm, 'MainDetails', undefined),
    YourDetails: getSafety(ConfigsReviewForm, 'YourDetails'),
    YourAddress: getSafety(ConfigsReviewForm, 'YourAddress'),
    YourProducts: getSafety(ConfigsReviewForm, 'YourProducts'),
    TreatmentListDetails: getSafety(ConfigsReviewForm, 'TreatmentListDetails'),
    isRecommendedByAFriend: reduxFormSelectors.selectIsRecommendedByAFriend(state),
  };
};

export const ConnectedReviewDetails = connect(mapStateToProps)(ReviewDetails);

ReviewDetails.propTypes = {
  history: PropTypes.shape({}).isRequired,
  clientAnswers: PropTypes.shape({
    yourDetailsSection: PropTypes.shape({}),
    questionsSection: PropTypes.shape({}),
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  questions: PropTypes.shape({}).isRequired,
  questionsSectionsConfig: PropTypes.arrayOf(PropTypes.shape({})),
  isRecommendedByAFriend: bool.isRequired,
  MainDetails: PropTypes.func,
  YourDetails: PropTypes.func,
  YourAddress: PropTypes.elementType,
  YourProducts: PropTypes.elementType,
  TreatmentListDetails: PropTypes.elementType,
};

ReviewDetails.defaultProps = {
  children: null,
  questionsSectionsConfig: [],
  MainDetails: DefaultMainDetails,
  YourDetails: DefaultYourDetails,
  YourAddress: memo(() => null),
  YourProducts: memo(() => null),
  TreatmentListDetails: memo(() => null),
};

ReviewDetails.contextType = BookingContext;
